/**
 * Collection infinite scroll — Section Rendering API
 *
 * Called from bundle.theme.js nextPage() when fetching regular (non-filter) pages.
 * Using the Section Rendering API means Shopify returns only the section's HTML as JSON
 * instead of a full page, significantly reducing payload size.
 *
 * @param {string}   url            - The next-page URL (already contains &sections=<id>)
 * @param {object}   collectionPage - The nn class instance from bundle.theme.js
 * @param {function} done           - The module-scoped c() function that clears body loading states
 */
window.fellaNextPage = function (url, collectionPage, done) {
  fetch(url, { method: "get", headers: { "Content-Type": "text/html" } })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      // best-seller collection caps at 30 visible products
      if (
        window.location.pathname.includes("best-seller") &&
        document.querySelectorAll(".product-index--item:not(.hidden)").length >=
          30
      ) {
        collectionPage.showFilterFeedback();
        return;
      }

      // Section Rendering API returns { "<section-id>": "<rendered html>" }
      var sectionHtml = Object.values(data)[0];
      var doc = new DOMParser().parseFromString(sectionHtml, "text/html");

      var products = doc.querySelector(".product-index");
      var paginationLink = doc.querySelector(".pagination--link");
      var nextUrl = paginationLink ? paginationLink.getAttribute("href") : "";

      collectionPage.nextLink.setAttribute("href", nextUrl);
      collectionPage.productIndex.push(products);
      collectionPage.nextLink
        .closest(".pagination--next")
        .classList.toggle("hidden", nextUrl === "");

      done();
      window.sendGAPageView(url);
    });
};

/**
 * Collection section hero/carousel — Swiper (config lives here so it can be tuned without rebuilding bundle.theme.js)
 *
 * Invoked from bundle.theme.js after Promise.all(module inits) resolves.
 * Requires Swiper (swiper-bundle from CDN) to be loaded globally.
 */
window.fellaInitCollectionSectionSwiper = function () {
  if (typeof Swiper === "undefined") return;
  var container = document.querySelector(
    ".collection-section-swiper-container",
  );
  if (!container || container.swiper) return;

  return new Swiper(".collection-section-swiper-container", {
    loop: true,
    slidesPerView: 4,
    spaceBetween: 0,
    slidesPerGroup: 4,
    loopFillGroupWithBlank: true,

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },

    breakpoints: {
      1024: {
        slidesPerView: 6,
        slidesPerGroup: 6,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        spaceBetween: 0,
      },
      0: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 0,
      },
    },
  });
};

(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // Show / hide password toggle
  // Uses event delegation on document so it works across Turbolinks navigations
  // without needing to re-bind on every page load.
  // ---------------------------------------------------------------------------
  function setEyeIcon(icon, name) {
    var use = icon.querySelector('use');
    if (!use) return;
    use.setAttribute('xlink:href', '#' + name);
    use.setAttribute('href', '#' + name);
  }

  // Initialise all password fields: password is hidden on load, so show eye-closed (state-based)
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.input-password-wrapper .icon--eye').forEach(function (icon) {
      setEyeIcon(icon, 'eye-closed');
    });
  });

  document.addEventListener('click', function (e) {
    var icon = e.target.closest('.input-password-wrapper .icon--eye');
    if (!icon) return;

    var input = icon.closest('.input-password-wrapper').querySelector('input');
    if (!input) return;

    var isPassword = input.getAttribute('type') === 'password';
    input.setAttribute('type', isPassword ? 'text' : 'password');

    // State-based: icon reflects current visibility state
    setEyeIcon(icon, isPassword ? 'eye' : 'eye-closed');
  });
})();


// ---------------------------------------------------------------------------
// Product page: checkout adds the current variant, then redirects to checkout
// ---------------------------------------------------------------------------
function getProductCheckoutLineItems() {
  var variantInput = document.querySelector('.product-form-id');
  var variantsEl = document.querySelector('.product--details--variants');
  var customiseEl = document.querySelector('.product--details--customise');
  var customiseVariantInput = document.querySelector('.product-form-customise-id');
  var variantId = variantInput && variantInput.value ? variantInput.value : '';

  if (!variantId) {
    var productJsonEl = document.getElementById('product_json');
    if (productJsonEl) {
      try {
        var productJson = JSON.parse(productJsonEl.innerHTML.replace(/\n/g, ''));
        if (productJson.variants && productJson.variants.length) {
          var defaultVariant = productJson.variants.find(function (variant) {
            return variant.available;
          });
          variantId = String((defaultVariant || productJson.variants[0]).id);
        }
      } catch (err) {}
    }
  }

  if (!variantId) return null;

  var lineVariantId = variantId;
  var customisationCount = 0;
  var properties = {};
  var invalid = false;

  if (customiseEl && customiseEl.classList.contains('has-selections')) {
    var checked = customiseEl.querySelectorAll(
      '.product--details--customise--option input:checked',
    );
    customisationCount = checked.length;
    var propIndex = 0;

    checked.forEach(function (input) {
      propIndex += 1;
      var option = input.closest('.product--details--customise--option');
      var descEl = option
        ? option.querySelector('.product--details--customise--option--description')
        : null;
      var propValue = descEl ? descEl.innerHTML : '';

      if (input.dataset.customCup === 'true') {
        var cupSelect = option ? option.querySelector('.cup-size-select select') : null;
        if (cupSelect) {
          cupSelect.classList.toggle('invalid', cupSelect.value === '');
          if (cupSelect.value === '') invalid = true;
          propValue = propValue + ' - size ' + cupSelect.value;
        }
      }

      properties['Customisation ' + propIndex] = propValue;
    });

    if (variantsEl && variantsEl.classList.contains('override') && customiseVariantInput) {
      lineVariantId = customiseVariantInput.value;
    }
  }

  if (invalid) return null;

  var items = [{ quantity: 1, id: parseInt(lineVariantId, 10), properties: properties }];

  if (customisationCount > 0 && customiseEl) {
    var customisationId = customiseEl.getAttribute('data-customisation-id');
    if (customisationId) {
      items.push({ quantity: customisationCount, id: parseInt(customisationId, 10) });
    }
  }

  return items;
}

function promptProductVariantSelection() {
  var body = document.querySelector('body');
  if (body) body.classList.add('sticky-product-add--show-variant');
  var variantButton = document.querySelector('.product--select-variant--button');
  if (variantButton) variantButton.click();
}

document.addEventListener(
  'click',
  function (e) {
    var btn = e.target.closest('[data-product-checkout]');
    if (!btn || btn.getAttribute('disabled') === 'true') return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var addButton = document.querySelector('.product--add-cart-button');
    if (
      addButton &&
      (addButton.classList.contains('sold-out') ||
        addButton.classList.contains('coming-soon') ||
        addButton.classList.contains('adding'))
    ) {
      return;
    }

    if (btn.classList.contains('loading')) return;

    var items = getProductCheckoutLineItems();
    if (!items) {
      var variantInput = document.querySelector('.product-form-id');
      if (!variantInput || !variantInput.value) promptProductVariantSelection();
      return;
    }

    btn.classList.add('loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        return response.json();
      })
      .then(function () {
        window.location.href = '/checkout';
      })
      .catch(function () {
        btn.classList.remove('loading');
      });
  },
  true,
);

document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-product-back-top]');
  if (!btn) return;
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

function updateProductBackTopVisibility() {
  var root = document.querySelector('[data-product-back-top-root]');
  if (!root) return;

  var fold = window.innerHeight || document.documentElement.clientHeight;
  var belowFold = window.scrollY > fold;

  root.classList.toggle('product-back-top--visible', belowFold);
  root.setAttribute('aria-hidden', belowFold ? 'false' : 'true');

  var button = root.querySelector('[data-product-back-top]');
  if (button) {
    if (belowFold) {
      button.removeAttribute('tabindex');
    } else {
      button.setAttribute('tabindex', '-1');
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  updateProductBackTopVisibility();
  window.addEventListener(
    'scroll',
    function () {
      updateProductBackTopVisibility();
    },
    { passive: true }
  );
  window.addEventListener('resize', function () {
    updateProductBackTopVisibility();
  });
  
  initProductIndexImageProgress();
});

// Turbolinks: full page reload does not run again; collection HTML is swapped without DOMContentLoaded.
document.addEventListener('turbolinks:load', function () {
  initProductIndexImageProgress();
});

// -----------------------------------------------------------------------------
// Collection grid: progress line under product image matches carousel data-index
// -----------------------------------------------------------------------------
function syncProductIndexImageProgress(container) {
  if (!container || !container.classList.contains('product-index--images')) return;
  var trackRoot = container.querySelector('.product-index--images--progress');
  var fill = container.querySelector('.product-index--images--progress--fill');
  if (!trackRoot || !fill) return;
  var total = parseInt(trackRoot.getAttribute('data-image-count'), 10);
  if (!total || total < 2) return;
  var raw = parseInt(container.getAttribute('data-index'), 10);
  if (isNaN(raw)) raw = 0;
  var idx = ((raw % total) + total) % total;
  var pct = ((idx + 1) / total) * 100;
  fill.style.width = pct + '%';
}

var productIndexProgressAttrObserver = null;

function ensureProductIndexProgressAttrObserver() {
  if (productIndexProgressAttrObserver || typeof MutationObserver === 'undefined') {
    return productIndexProgressAttrObserver;
  }
  productIndexProgressAttrObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'attributes' && m.attributeName === 'data-index' && m.target.classList) {
        syncProductIndexImageProgress(m.target);
      }
    });
  });
  return productIndexProgressAttrObserver;
}

function bindProductIndexImageProgress(container) {
  if (!container) return;
  var obs = ensureProductIndexProgressAttrObserver();
  if (!obs) return;
  syncProductIndexImageProgress(container);
  obs.observe(container, {
    attributes: true,
    attributeFilter: ['data-index'],
  });
}

function initProductIndexImageProgress(root) {
  if (typeof MutationObserver === 'undefined') return;
  ensureProductIndexProgressAttrObserver();
  var scope =
    root && typeof root.querySelectorAll === 'function' ? root : document;
  scope.querySelectorAll('.product-index--images').forEach(bindProductIndexImageProgress);
}

/**
 * Collection grid: swatch click swaps product images via AJAX but does not reset carousel
 * `data-index`. Reset to the first image and sync the progress fill.
 */
function resetProductIndexImageProgressOnSwatchClick(e) {
  var swatch = e.target.closest('.product-index--interface--swatch-list a.swatch');
  if (!swatch) return;
  var item = swatch.closest('.product-index--item');
  if (!item) return;
  var container = item.querySelector('.product-index--images');
  if (!container) return;
  container.setAttribute('data-index', '0');
  syncProductIndexImageProgress(container);
}

document.addEventListener('click', resetProductIndexImageProgressOnSwatchClick);

// -----------------------------------------------------------------------------
// Featured Products section: carousel arrows + infinite reposition (same behaviour
// as collection PLP; Collection JS only binds the first .product-index in .collection)
// -----------------------------------------------------------------------------
var featuredCarouselAnimating = new WeakMap();
var featuredCarouselLastClick = new WeakMap();

function featuredCarouselNormalizeIndex(idx, len) {
  if (!len) return 0;
  return ((idx % len) + len) % len;
}

document.addEventListener(
  'click',
  function (ev) {
    var btn = ev.target.closest('.featured-products .product-index--images--button');
    if (!btn) return;
    var container = btn.closest('.product-index--images');
    if (!container || !container.closest('.featured-products')) return;

    ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();

    var slides = container.querySelectorAll('.product-index--images--image');
    var slideCount = slides.length;
    if (slideCount < 2) return;

    var now = Date.now();
    var last = featuredCarouselLastClick.get(container) || 0;
    if (featuredCarouselAnimating.get(container) || now - last < 400) return;
    featuredCarouselLastClick.set(container, now);
    featuredCarouselAnimating.set(container, true);

    var direction = btn.classList.contains('previous') ? -1 : 1;
    var i = parseInt(container.getAttribute('data-index'), 10);
    if (isNaN(i)) i = 0;
    i = featuredCarouselNormalizeIndex(i + direction, slideCount);

    container.setAttribute('data-index', String(i));
    syncProductIndexImageProgress(container);

    setTimeout(function () {
      featuredCarouselAnimating.set(container, false);
      if (
        (direction === -1 && i < 2) ||
        (direction === 1 && slideCount - i < 2)
      ) {
        var half = slideCount / 2;
        var newIdx = i + (direction === 1 ? -half : half);
        newIdx = featuredCarouselNormalizeIndex(newIdx, slideCount);
        container.classList.add('no-anim');
        container.setAttribute('data-index', String(newIdx));
        syncProductIndexImageProgress(container);
        setTimeout(function () {
          container.classList.remove('no-anim');
        }, 10);
      }
    }, 500);
  },
  true
);

if (typeof MutationObserver !== 'undefined') {
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('product-index--images')) {
          bindProductIndexImageProgress(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.product-index--images').forEach(bindProductIndexImageProgress);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
}

// ---------------------------------------------------------------------------
// Product gallery: desktop = flex column + scroll; mobile = Swiper (separate DOM)
// ---------------------------------------------------------------------------
/** Pixels to leave above the image when scrolling (sticky header / breathing room). */
var DESKTOP_GALLERY_SCROLL_OFFSET = 100;

function scrollGalleryToThumbIndex(thumb, stack) {
  var idx = thumb.getAttribute('data-thumb-index');
  if (idx == null || idx === '') return;
  var slide = stack.querySelector('.product--image--gallery-slide[data-gallery-index="' + idx + '"]');
  if (!slide) return;
  var offset = DESKTOP_GALLERY_SCROLL_OFFSET;
  var top = slide.getBoundingClientRect().top + window.scrollY - offset;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
}

/** Scroll `.product--image--thumbs-inner` so the active thumb stays in the visible strip. */
function scrollProductThumbsToActive(thumbRow, behavior) {
  var inner = thumbRow.querySelector('.product--image--thumbs-inner');
  if (!inner) return;
  var active = thumbRow.querySelector('.product--image--thumb-wrapper.product--image--thumb--active');
  if (!active) return;

  var innerRect = inner.getBoundingClientRect();
  var activeRect = active.getBoundingClientRect();
  var padding = 4;
  var delta = 0;
  if (activeRect.top < innerRect.top + padding) {
    delta = activeRect.top - innerRect.top - padding;
  } else if (activeRect.bottom > innerRect.bottom - padding) {
    delta = activeRect.bottom - innerRect.bottom + padding;
  }
  if (delta === 0) return;

  var targetTop = inner.scrollTop + delta;
  if (behavior === 'smooth' && typeof inner.scrollTo === 'function') {
    inner.scrollTo({ top: targetTop, behavior: 'smooth' });
  } else {
    inner.scrollTop = targetTop;
  }
}

function setActiveThumbForIndex(thumbRow, indexStr, thumbScrollBehavior) {
  if (indexStr == null || indexStr === '') return;
  thumbRow.querySelectorAll('.product--image--thumb-wrapper').forEach(function (t) {
    var isActive = t.getAttribute('data-thumb-index') === String(indexStr);
    t.classList.toggle('product--image--thumb--active', isActive);
  });
  scrollProductThumbsToActive(thumbRow, thumbScrollBehavior || 'auto');
}

/** Index (string) of the gallery slide with the largest visible area in the viewport. */
function getGalleryIndexMostVisibleInViewport(stack) {
  var slides = stack.querySelectorAll('.product--image--gallery-slide');
  if (!slides.length) return null;

  var vh = window.innerHeight || document.documentElement.clientHeight;
  var vw = window.innerWidth || document.documentElement.clientWidth;
  var bestIdx = null;
  var bestArea = 0;

  for (var i = 0; i < slides.length; i++) {
    var r = slides[i].getBoundingClientRect();
    var visibleTop = Math.max(0, r.top);
    var visibleBottom = Math.min(vh, r.bottom);
    var visibleLeft = Math.max(0, r.left);
    var visibleRight = Math.min(vw, r.right);
    var visibleH = visibleBottom - visibleTop;
    var visibleW = visibleRight - visibleLeft;
    if (visibleH <= 0 || visibleW <= 0) continue;
    var area = visibleH * visibleW;
    if (area > bestArea) {
      bestArea = area;
      bestIdx = slides[i].getAttribute('data-gallery-index');
    }
  }
  return bestIdx;
}

function initDesktopProductGallery() {
  document.querySelectorAll('[data-product-thumbs]').forEach(function (thumbRow) {
    var root = thumbRow.closest('.product--image');
    var stack = root && root.querySelector('[data-product-gallery-desktop]');
    if (!stack) return;

    var firstThumb = thumbRow.querySelector('.product--image--thumb-wrapper');
    if (firstThumb && !thumbRow.querySelector('.product--image--thumb--active')) {
      firstThumb.classList.add('product--image--thumb--active');
    }

    if (thumbRow.dataset.desktopGalleryBound) return;
    thumbRow.dataset.desktopGalleryBound = '1';

    function syncActiveThumbFromViewport() {
      var idx = getGalleryIndexMostVisibleInViewport(stack);
      if (idx != null) setActiveThumbForIndex(thumbRow, idx);
    }

    var thumbSyncRaf = null;
    function scheduleSyncActiveThumbFromViewport() {
      if (thumbSyncRaf != null) return;
      thumbSyncRaf = requestAnimationFrame(function () {
        thumbSyncRaf = null;
        syncActiveThumbFromViewport();
      });
    }

    thumbRow.addEventListener('click', function (e) {
      var thumb = e.target.closest('.product--image--thumb-wrapper');
      if (!thumb || !thumbRow.contains(thumb)) return;
      var idx = thumb.getAttribute('data-thumb-index');
      setActiveThumbForIndex(thumbRow, idx, 'smooth');
      scrollGalleryToThumbIndex(thumb, stack);
    });

    thumbRow.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var thumb = e.target.closest('.product--image--thumb-wrapper');
      if (!thumb || !thumbRow.contains(thumb)) return;
      e.preventDefault();
      var idx = thumb.getAttribute('data-thumb-index');
      setActiveThumbForIndex(thumbRow, idx, 'smooth');
      scrollGalleryToThumbIndex(thumb, stack);
    });

    window.addEventListener('scroll', scheduleSyncActiveThumbFromViewport, { passive: true });
    window.addEventListener('resize', scheduleSyncActiveThumbFromViewport);

    syncActiveThumbFromViewport();
  });
}

function initMobileProductCarousel(carousel) {
  if (window.matchMedia('(min-width: 1024px)').matches) {
    if (carousel.swiper) {
      carousel.swiper.destroy(true, true);
    }
    return;
  }
  if (carousel.swiper) return;

  var paginationMobile = document.querySelector('.product--image__pagination--mobile');
  var slideCount = carousel.querySelectorAll('.swiper-slide').length;
  var useLoop = slideCount > 1;

  new Swiper(carousel, {
    slidesPerView: 1.05,
    spaceBetween: 2.5,
    loop: useLoop,
    breakpoints: {
      1024: { slidesPerView: 1 },
    },
    pagination: paginationMobile
      ? {
          el: paginationMobile,
          clickable: true,
          dynamicBullets: true,
        }
      : {},
  });
}

function initProductCarousels() {
  document.querySelectorAll('.product--image--carousel--mobile').forEach(initMobileProductCarousel);
  initDesktopProductGallery();
}

var productCarouselResizeTimer;
window.addEventListener('resize', function () {
  clearTimeout(productCarouselResizeTimer);
  productCarouselResizeTimer = setTimeout(function () {
    document.querySelectorAll('.product--image--carousel--mobile').forEach(function (el) {
      if (window.matchMedia('(min-width: 1024px)').matches) {
        if (el.swiper) {
          el.swiper.destroy(true, true);
        }
      } else if (!el.swiper) {
        initMobileProductCarousel(el);
      } else {
        el.swiper.update();
      }
    });
  }, 150);
});

document.addEventListener('DOMContentLoaded', initProductCarousels);
document.addEventListener('shopify:section:load', initProductCarousels);
setTimeout(initProductCarousels, 1000);
// -----------------------------------------------------------------------------
// Global ribbon (moved from bundle.theme.js)
// — Note rotation only when `.ribbon--note` exists; `.ribbon--close` always bound.
// -----------------------------------------------------------------------------

(function () {
  'use strict';

  var COOKIE_NAME = 'closed-global-note';

  function getCookie(name) {
    var cookies = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0; i < cookies.length; i++) {
      var parts = cookies[i].split('=');
      if (parts[0] === name) {
        try {
          return decodeURIComponent(parts.slice(1).join('='));
        } catch (e) {
          return parts.slice(1).join('=');
        }
      }
    }
    return undefined;
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie =
      name +
      '=' +
      encodeURIComponent(String(value)) +
      ';path=/;expires=' +
      d.toUTCString();
  }

  /**
   * Rotating ribbon notes with horizontal scroll when content overflows.
   * Mirrors the former bundle `S` class (js-cookie + same timings).
   */
  function FellaRibbon() {
    this.closeClickHandler = this.closeClickHandler.bind(this);
    this.onScreenResize = this.onScreenResize.bind(this);
    this.animate = this.animate.bind(this);
    this.animateNextNote = this.animateNextNote.bind(this);

    this.screenResizeTimeout = null;
    this.scrollNoteTimeout = null;
    this.resetNoteTimeout = null;
    this.nextNoteInterval = null;
    this.noteAnimationTiming = 10000;
    this.body = document.querySelector('body');

    if (
      getCookie(COOKIE_NAME) != 1 &&
      this.body &&
      this.body.classList.contains('has-ribbon')
    ) {
      this.body.classList.add('show-ribbon');
    }
  }

  FellaRibbon.prototype.init = function () {
    this.el = document.querySelector('.ribbon');
    this.notesEl = document.querySelector('.ribbon--notes');
    if (!this.el) return;

    this.closeLink = this.el.querySelector('.ribbon--close');
    if (!this.closeLink) {
      this.closeLink = document.querySelector('.ribbon--close');
    }
    if (this.closeLink) {
      this.closeLink.addEventListener('click', this.closeClickHandler);
    }

    if (document.querySelector('.ribbon--note')) {
      window.addEventListener('resize', this.onScreenResize);
      this.animate();
    }
  };

  FellaRibbon.prototype.closeClickHandler = function (event) {
    setCookie(COOKIE_NAME, 1, 1);
    if (this.body) this.body.classList.remove('show-ribbon');
    event.preventDefault();
  };

  FellaRibbon.prototype.onScreenResize = function () {
    var self = this;
    clearTimeout(this.screenResizeTimeout);
    this.screenResizeTimeout = setTimeout(function () {
      self.animate();
    }, 100);
  };

  FellaRibbon.prototype.animate = function () {
    var self = this;
    var active = this.el.querySelector('.ribbon--note.active');
    var activeOut = this.el.querySelector('.ribbon--note.active-out');
    if (active) active.classList.remove('active');
    if (activeOut) activeOut.classList.remove('active-out');

    clearInterval(this.nextNoteInterval);
    this.nextNoteInterval = setInterval(function () {
      self.animateNextNote();
    }, this.noteAnimationTiming);
    this.animateNextNote();
  };

  FellaRibbon.prototype.animateNextNote = function () {
    var notes = this.getNotes();
    var current = this.el.querySelector('.ribbon--note.active');
    var currentIndex;
    var nextIndex = 0;

    if (current) {
      currentIndex = notes.indexOf(current);
      nextIndex = (currentIndex + 1) % notes.length;
      if (currentIndex !== nextIndex) {
        current.classList.remove('active');
        current.classList.add('active-old');
        this.resetNoteTimeout = setTimeout(function () {
          var content = current.querySelector('.ribbon--note--content');
          current.classList.remove('active-old');
          if (content) content.removeAttribute('style');
        }, 750);
      }
    }

    var next = notes[nextIndex];
    if (!next || !this.notesEl) return;

    next.classList.remove('active-old');
    next.classList.add('active');

    var scrollDiff = next.clientWidth - this.notesEl.clientWidth;
    next.setAttribute('data-scroll-diff', scrollDiff);

    if (scrollDiff > 0) {
      var o = scrollDiff + 50;
      var durationMs = 50 * o;
      var maxBeforeInterval = this.noteAnimationTiming - 1000;
      if (durationMs > this.noteAnimationTiming) {
        durationMs = this.noteAnimationTiming;
      }
      if (durationMs > maxBeforeInterval) {
        durationMs = maxBeforeInterval;
      }

      var contentEl = next.querySelector('.ribbon--note--content');
      if (!contentEl) return;

      contentEl.removeAttribute('style');
      if (current && currentIndex === nextIndex) {
        contentEl.setAttribute('style', 'opacity: 0');
      }

      this.scrollNoteTimeout = setTimeout(function () {
        contentEl.setAttribute(
          'style',
          'transition:transform ' +
            durationMs +
            'ms linear, opacity 250ms ease;transform:translateX(-' +
            o +
            'px);'
        );
      }, 750);
    }
  };

  FellaRibbon.prototype.getNotes = function () {
    return Array.prototype.slice.call(this.el.querySelectorAll('.ribbon--note'));
  };

  FellaRibbon.prototype.destroy = function () {
    if (this.el && this.closeLink) {
      this.closeLink.removeEventListener('click', this.closeClickHandler);
    }
    window.removeEventListener('resize', this.onScreenResize);
    clearTimeout(this.screenResizeTimeout);
    clearTimeout(this.scrollNoteTimeout);
    clearTimeout(this.resetNoteTimeout);
    clearInterval(this.nextNoteInterval);
  };

  var ribbonInstance = null;

  function bootRibbon() {
    if (ribbonInstance) {
      ribbonInstance.destroy();
      ribbonInstance = null;
    }
    var hasNotes = document.querySelector('.ribbon--note');
    var hasClose = document.querySelector('.ribbon--close');
    if (!hasNotes && !hasClose) return;

    ribbonInstance = new FellaRibbon();
    ribbonInstance.init();
  }

  document.addEventListener('DOMContentLoaded', bootRibbon);
  document.addEventListener('turbolinks:load', bootRibbon);
})();


(function() {
  var container = document.querySelector('.product .product--details--container');
  if (!container) return;

  function setExpandingHeights() {
    container.querySelectorAll('.product--details--info-box.open .product--details--info-box--description').forEach(function(el) {
      el.style.maxHeight = el.scrollHeight + 'px';
    });
  }

  function scrollToTarget(id) {
    var el = document.getElementById(id);
    if (!el) return;
    var top = el.getBoundingClientRect().top + (window.pageYOffset - 100);
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  container.addEventListener('click', function(e) {
    var title = e.target.closest('.product--details--info-box--title');
    if (!title) return;

    var scrollId = title.getAttribute('data-scroll-to');
    if (scrollId) {
      e.preventDefault();
      e.stopImmediatePropagation();
      scrollToTarget(scrollId);
      return;
    }

    var infoBox = title.closest('.product--details--info-box');
    if (!infoBox) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    infoBox.classList.toggle('open');
    requestAnimationFrame(setExpandingHeights);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setExpandingHeights);
  } else {
    setExpandingHeights();
  }
})();

/**
 * Minicart · accelerated (Shop Pay, etc.): `content_for_additional_checkout_buttons`
 * is fetched via the Section Rendering API and injected after the minicar `.cart-interaction`
 * is replaced in JS (`reloadCarts` in bundle.theme.js). Server-rendered markup would be
 * torn down on each cart update; this re-runs the same Liquid on demand.
 */
(function () {
  var SECTION_ID = 'minicart-additional-checkout';
  var debounceMs = 80;
  var debounceId = null;
  var inFlight = false;
  if (!document.querySelector('.header--minicart .cart-interaction')) return;

  function cartListPath() {
    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.cart
    ) {
      try {
        return new URL(Shopify.routes.cart, window.location.origin).pathname;
      } catch (e) {
        var s = String(Shopify.routes.cart).split('?')[0];
        if (s.indexOf('http') === 0) {
          try {
            return new URL(s, window.location.origin).pathname;
          } catch (e2) {
            return '/cart';
          }
        }
        return s || '/cart';
      }
    }
    return '/cart';
  }

  function fellaLoadMinicarAdditionalCheckout() {
    if (inFlight) return;
    var cart = document.querySelector(
      '.header--minicart .cart-interaction',
    );
    if (!cart) return;
    var root = cart.querySelector(
      '[data-minicart-additional-checkout-pending]',
    );
    if (!root) return;
    inFlight = true;
    var rootRef = root;
    var url = cartListPath() + '?sections=' + SECTION_ID + '&_=' + Date.now();
    fetch(url, { method: 'GET', credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('minicar checkout section');
        return res.json();
      })
      .then(function (data) {
        var sectionHtml = data[SECTION_ID];
        if (typeof sectionHtml !== 'string') return;
        var parsed = new DOMParser().parseFromString(
          sectionHtml,
          'text/html',
        );
        var next = parsed.querySelector(
          '[data-minicart-additional-checkout-root]',
        );
        if (next && rootRef.parentNode) {
          rootRef.replaceWith(next);
        } else {
          if (rootRef.getAttribute) {
            rootRef.removeAttribute('data-minicart-additional-checkout-pending');
          }
        }
        if (window.Shopify && window.Shopify.PaymentButton) {
          try {
            window.Shopify.PaymentButton.init();
          } catch (e) {}
        }
        document.dispatchEvent(
          new CustomEvent('fella:minicar-additional-checkout:loaded', {
            bubbles: true,
            detail: { section: SECTION_ID },
          }),
        );
      })
      .catch(function () {
        if (rootRef && rootRef.parentNode && rootRef.removeAttribute) {
          rootRef.removeAttribute('data-minicart-additional-checkout-pending');
        }
      })
      .finally(function () {
        inFlight = false;
      });
  }

  var minicarCart = document.querySelector(
    '.header--minicart .cart-interaction',
  );

  function scheduleLoad() {
    clearTimeout(debounceId);
    debounceId = setTimeout(function () {
      if (
        document.querySelector(
          '.header--minicart [data-minicart-additional-checkout-pending]',
        )
      ) {
        fellaLoadMinicarAdditionalCheckout();
      }
    }, debounceMs);
  }

  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].type !== 'childList') continue;
      if (
        (minicarCart &&
          minicarCart.querySelector(
            '[data-minicart-additional-checkout-pending]',
          )) ||
        document.querySelector(
          '.header--minicart [data-minicart-additional-checkout-pending]',
        )
      ) {
        scheduleLoad();
        return;
      }
    }
  });
  if (minicarCart) {
    mo.observe(minicarCart, { childList: true, subtree: true });
  }

  if (document.querySelector(
    '.header--minicart [data-minicart-additional-checkout-pending]',
  )) {
    scheduleLoad();
  }

  var showMo = new MutationObserver(function () {
    if (document.body.classList.contains('show-minicart')) scheduleLoad();
  });
  showMo.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  window.fellaLoadMinicarAdditionalCheckout = fellaLoadMinicarAdditionalCheckout;
})();
